import React, { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import { archiveApi } from "@/components/nds/BulkArchiveBar";
import { Items } from "@/pages/admin/ArchiveCenterPage";

/** Every record tied to this resident, by type: Active / Archived / All, group archive / unarchive, SA permanent delete. */
export default function ResidentArchiveTab({ resident }) {
  const [meta, setMeta] = useState(null);
  const [error, setError] = useState(null);
  const [kind, setKind] = useState(() => localStorage.getItem("tea_res_archive_kind") || "paychecks");
  const load = () => archiveApi.get("/kinds", { resident_id: resident.id }).then(setMeta)
    .catch((e) => setError(e?.response?.status === 403 ? "You need the 'Archive & unarchive records' permission." : "Couldn't load records"));
  useEffect(() => { load(); }, [resident.id]); // eslint-disable-line react-hooks/exhaustive-deps
  const pick = (k) => { localStorage.setItem("tea_res_archive_kind", k); setKind(k); };
  if (error) return <p data-testid="resident-archive-tab-error" className="text-sm text-red-300">{error}</p>;
  if (!meta) return <div className="flex items-center gap-2 text-nex-muted text-sm"><Loader2 className="h-4 w-4 animate-spin" /> Loading…</div>;
  const cur = meta.kinds.some((k) => k.kind === kind) ? kind : meta.kinds[0]?.kind;
  const groups = [...new Set(meta.kinds.map((k) => k.group))];
  return (
    <div data-testid="resident-archive-tab" className="space-y-4">
      <p className="text-xs text-nex-muted">Archived items are hidden from every card. Archiving a money item takes its amounts out of balances and totals; unarchiving puts them back.</p>
      {groups.map((g) => (
        <div key={g} className="flex flex-wrap items-center gap-1.5">
          <span className="w-32 font-mono text-[9px] tracking-[0.2em] uppercase text-nex-muted">{g}</span>
          {meta.kinds.filter((k) => k.group === g).map((k) => (
            <button key={k.kind} type="button" onClick={() => pick(k.kind)} data-testid={`resident-archive-kind-${k.kind}`} aria-pressed={cur === k.kind}
              className={`px-2.5 py-1 rounded-full border font-mono text-[9px] tracking-[0.16em] uppercase transition-colors ${cur === k.kind ? "border-nex-gold text-nex-gold bg-nex-gold/10" : "border-white/10 text-nex-muted hover:text-nex-silver"}`}>
              {k.label} · {k.all}{k.archived ? ` (${k.archived} archived)` : ""}
            </button>
          ))}
        </div>
      ))}
      {cur && <Items key={cur} kind={cur} meta={meta} residentId={resident.id} onChanged={load} />}
    </div>
  );
}
